var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar'),_c('header',{staticClass:"header",attrs:{"id":"header"}},[_c('navigation')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }